// This is an example page component. Copy it to make
// new pages. When you copy it, make sure to add a
// route to the App.jsx file.
function OtherPage() {
  return (
    // You can put other components here.
    <h1>Other</h1>
  );
}

export default OtherPage;
